import ClipLoader from 'react-spinners/ClipLoader';

function Loading({ isLoading }: { isLoading: boolean }) {
  return <ClipLoader color="#566ffe" loading={isLoading} size={150} />;
}

export default Loading;
